import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const reviewer = new Restful(project, 'reviewer')
reviewer.import = function(data) {
  const url = project + 'reviewer/import'
  return http.put(url, data).then(res => {
    return res
  })
}

const reviewerApply = new Restful(project, 'reviewer/apply')

reviewerApply.accepted = (id, data) => {
  const url = project + 'reviewer/apply/handle/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

reviewerApply.getByUser = data => {
  const url = project + 'reviewer/apply/uid'
  return http.get(url, data).then(res => {
    return res
  })
}

const minvitedReviewer = new Restful(project, 'minvited/reviewer')

minvitedReviewer.count = data => {
  const url = project + 'minvited/reviewer/count'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.time = (id, data) => {
  const url = project + 'minvited/reviewer/time/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.like = data => {
  const url = project + 'minvited/reviewer/like'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.remove = (id, data) => {
  const url = project + 'minvited/reviewer/remove/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.confirm = data => {
  const url = project + 'minvited/reviewer/confirm'
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.search = data => {
  const url = project + 'minvited/reviewer/search'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.decision = data => {
  const url = project + 'minvited/reviewer/decision'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.fileVisable = (id, data) => {
  const url = project + `minvited/reviewer/file/visible/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.authorFileVisable = (id, data) => {
  const url = project + `minvited/reviewer/author_file/visible/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.rating = (id, data) => {
  const url = project + `minvited/reviewer/rating/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

// suggest
minvitedReviewer.suggest = (id, data) => {
  const url = project + `minvited/reviewer/suggest_refer_num/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

// 原审稿人查看详情接口（现不用）
minvitedReviewer.decisionQuery = (id, data) => {
  const url = project + 'minvited/reviewer/decision/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

// 审稿人查看详情列表（新）
minvitedReviewer.decisionHistory = (id, data) => {
  const url = project + 'minvited/reviewer/decision/history/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.alldecision = data => {
  const url = project + 'minvited/reviewer/alldecision'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.token = data => {
  const url = project + 'minvited/reviewer/token'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.countReport = data => {
  const url = project + 'minvited/reviewer/count/report'
  return http.get(url, data).then(res => {
    return res
  })
}

minvitedReviewer.authorReply = data => {
  const url = project + 'minvited/reviewer/editor/author_reply'
  return http.post(url, data).then(res => {
    return res
  })
}

minvitedReviewer.remind = (id, data) => {
  const url = project + 'minvited/reviewer/remind/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.cancel = data => {
  const url = project + 'minvited/reviewer/cancel'
  return http.put(url, data).then(res => {
    return res
  })
}

minvitedReviewer.import = data => {
  const url = project + 'minvited/reviewer/import'
  return http.put(url, data).then(res => {
    return res
  })
}
minvitedReviewer.importConfirm = data => {
  const url = project + 'minvited/reviewer/import/confirm'
  return http.put(url, data).then(res => {
    return res
  })
}

const reviewerInvite = new Restful(project, 'reviewer/invite')
reviewerInvite.reviews = data => {
  const url = project + 'reviewer/invite'
  return http.get(url, data).then(res => {
    return res
  })
}
reviewerInvite.reviewsCommit = data => {
  const url = project + 'reviewer/invite'
  return http.post(url, data).then(res => {
    return res
  })
}
reviewerInvite.count = data => {
  const url = project + 'reviewer/invite/count'
  return http.get(url, data).then(res => {
    return res
  })
}
// 作者查看历史版本审稿报告
reviewerInvite.report = (id, data) => {
  const url = project + 'reviewer/invite/report/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
reviewerInvite.details = (id, data) => {
  const url = project + 'reviewer/invite/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
reviewerInvite.confirm = data => {
  const url = project + 'reviewer/invite/confirm'
  return http.put(url, data).then(res => {
    return res
  })
}

reviewerInvite.accept = data => {
  const url = project + 'minvited/reviewer/accept'
  return http.put(url, data).then(res => {
    return res
  })
}

// 拒绝审稿
reviewerInvite.refuse = (id, data) => {
  const url = project + 'minvited/reviewer/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

const reviewerBoard = new Restful(project, 'reviewer/board')
reviewerBoard.import = function(data) {
  const url = project + 'reviewer/board/import'
  return http.put(url, data).then(res => {
    return res
  })
}
reviewerBoard.email = function(email, data = {}) {
  const url = project + 'reviewer/board/email/' + email
  return http.get(url, data).then(res => {
    return res
  })
}

const reviewerWait = new Restful(project, 'mwait/reviewer')

export {
  reviewer,
  reviewerBoard,
  reviewerApply,
  minvitedReviewer,
  reviewerInvite,
  reviewerWait
}
export default reviewer
